(function(angular){
	'use strict';
	angular.module('planUpgradeModule', [
		'coreModule',
		'planModule'
	]);
})(window.angular);